<template>
	<div class="h-full survey-hfull-class h-full">
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex h-full flex-column h-full">
			<TopAppBarDrawer></TopAppBarDrawer>
		<!-- <TopAppBar
			v-if="url_list_type == false"
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
			staticMode="true"
		>
		</TopAppBar> -->
			<component :is="listType"></component>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script>
/**
 * 단독설문 메인 컴포넌트(independent survey main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import CategoryList from "@/components/common/CategoryList.vue";
import ServiceCategoryList from "@/components/common/ServiceCategoryList.vue";

export default {
	name: "survey",
	components: {
		total: () => import("@/components/independentSurvey/list/Total.vue"),
		my: () => import("@/components/independentSurvey/list/My.vue"),
		result: () => import("@/components/independentSurvey/list/Result.vue"),
		category: () => import("@/components/independentSurvey/list/Category.vue"),
		totalview: () => import("@/components/independentSurvey/TotalView.vue"),
		TopAppBar,
		TopAppBarDrawer
	},

	data() {
		return {
			listType: "total",
			url_list_type: false
		};
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {
			let routerLen = this.$route.matched.length;
			if (this.$route.query && this.$route.query.listType === "category") {
				let learnBack = localStorage.getItem("mysurvey");
				if (learnBack == "myinformation") {
					localStorage.removeItem("mysurvey");
					this.setTopAppBarBackToMyInformation(this.$t("212"));
				} else {
					if (routerLen == 1) {
						this.url_list_type = true;
						this.leftBtnMode = "arrow_back";
						this.rightBtnMode = "search";
						this.title = localStorage.getItem('brandName');
						this.leftBtnMethod = () => {
							this.$router.push({
								name: "IndependentSurvey",
							});
						};
						this.rightBtnMethod = "";
					} else {
						this.url_list_type = true;
						this.leftBtnMode = "arrow_back";
						this.rightBtnMode = "search";
						this.title = localStorage.getItem('brandName');
						this.leftBtnMethod = () => {
							this.$router.go(-1);
						};
						this.rightBtnMethod = "";
					}
				}
			} else {
				this.url_list_type = false;
				this.setTopAppBarHomeBlank(localStorage.getItem('brandName'));
			}
		},
	},
	computed: {
		isListType() {
			return this.$route.query.listType || "total";
		},
	},

	mounted() {
		if (this.$route.query && this.$route.query.listType === "category") {
			let learnBack = localStorage.getItem("mysurvey");
			if (learnBack == "myinformation") {
				localStorage.removeItem("mysurvey");
				this.setTopAppBarBackToMyInformation(this.$t("212"));
			} else {
				this.url_list_type = true;
				this.leftBtnMode = "arrow_back";
				this.rightBtnMode = "search";
				this.title = localStorage.getItem('brandName');
				this.leftBtnMethod = () => {
					this.$router.go(-1);
				};
				this.rightBtnMethod = "";
			}
			 this.listType = 'category';
		} else {
			//console.log(this.$route, ' ___dildar khan')
			if(this.$route.name === 'IndependentSurvey'){
			 this.listType = this.$route.query.listType || "total";
			// console.log(this.listType , 'coommm')
			} else{
				this.listType = false
			}
			this.url_list_type = false;
			this.setTopAppBarHomeBlank(localStorage.getItem('brandName'));
		}

		// set header title
		const ripples = [].map.call(
			document.querySelectorAll(".ripple-item"),
			function (el) {
				let ripple = new MDCRipple.attachTo(el);
				return ripple;
			}
		);
	},

	methods: {
		changeMode(mode) {
			this.listType = mode;
		}
	}
};
</script>
